<template>
  <div class="content_box contact">
    <Header @onSearch="onSearch" style="background: #8e86dd">
      <!-- 工具栏 -->
      <Tollbar
        class="header_menu_box"
        :list="tollbarList"
        :moreTool="moreToolbarList"
        type="1"
        theme="1"
        :selectList="selectList"
        :isShowSearch.sync="isShowSearch"
        :isShowSelect.sync="isShowSelect"
        @menuClick="menuClick"
      ></Tollbar>
    </Header>
    <div class="content_wrap detail">
      <div class="detail_header">
        <div class="detail_header_info">
          <div class="detail_header_info_name">
            {{ companyInfo == null ? "" : companyInfo?.base?.companyName }}
            <!-- <OverflowTooltip :tip="companyInfo?.base?.companyName" /> -->
            <i
              v-if="companyInfo?.base?.collectIds != '-'"
              class="iconfont icon-shoucang active"
            ></i>
          </div>
          <div
            class="detail_header_info_address"
            v-if="
              companyInfo?.base?.durant != '-' || companyInfo?.base?.city != '-'
            "
          >
            <img :src="companyInfo?.base?.img" />
            <div class="detail_header_info_address_txt">
              <span v-if="companyInfo?.base?.durant != '-'">{{
                companyInfo?.base?.durant
              }}</span
              ><span
                v-if="
                  companyInfo?.base?.city != '-' &&
                  companyInfo?.base?.durant != '-'
                "
                >&nbsp;,&nbsp;</span
              ><span v-if="companyInfo?.base?.city != '-'">{{
                companyInfo?.base?.city
              }}</span>
              <span v-if="companyInfo?.base?.province != '-'">
                , {{ companyInfo?.base?.province }}</span
              >
              <span v-if="companyInfo?.base?.country != '-'">
                , {{ companyInfo?.base?.country }}</span
              >
            </div>
          </div>

          <el-tabs class="detail_header_info_label" v-model="activeLabelTab">
            <el-tab-pane
              :key="index"
              v-for="(item, index) in companyInfo?.labels"
              :label="item.label"
              :name="item.label"
              :disabled="true"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="detail_header_dqi">
          <!-- echart -->
          <div class="new-content-top-right">
            <div class="new-content-right-company">
              <div ref="companyRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CompanyDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CompanyDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CompanyTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc2") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc3") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="new-content-right-country">
              <div ref="countryRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CountryDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CountryDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CountryTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc2") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_content">
        <div class="detail_content_tab">
          <div
            class="detail_tab_item"
            :class="{ active: activeTab == tabItem.type }"
            v-for="tabItem in detailTabs"
            :key="tabItem.type"
            @click="changeTab(tabItem.type)"
          >
            {{ tabItem.name }}
          </div>
        </div>
        <div class="detail_content_tab_content">
          <ContactInfo
            class="detail_content_tab_con_echart"
            v-if="activeTab == '1'"
            :isShowSearch="isShowSearch"
            :isShowSelect="isShowSelect"
            :detailInfo="companyInfo"
          />
          <OrgStructure
            class="detail_content_tab_con_echart"
            v-if="activeTab == '2'"
          />
        </div>
      </div>
    </div>
    <!-- 认证-->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="batchDialogVisible"
      :before-close="
        () => {
          batchDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_1000"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/batch_icon.png" />
        </div>
        <div class="dialog_title_img_text">Information Authentication</div>
        <div class="dialog_content_body">
          <div class="batch_title">Authentication Method:</div>

          <el-radio label="1" v-model="batchChosen"
            >I'm here to claim it</el-radio
          >
          <div class="radio_tips">
            This option means that you have verified and confirmed the
            information of the selected personnel. After clicking "confirm", the
            system will immediately send the relevant personnel Mark as
            authenticated status;
          </div>
          <el-radio label="2" v-model="batchChosen"
            >Authentication Service</el-radio
          >
          <div class="radio_tips">
            This option provides offline authentication services for the
            information of the selected personnel. After the authentication is
            confirmed, the system will promptly change the authentication status
            of the relevant personnel and notify you via email;
          </div>
          <el-radio label="3" v-model="batchChosen">Upload List</el-radio>
          <div class="radio_tips">
            <el-button type="text">Download template</el-button>
            <el-button type="text">upload</el-button>
          </div>
          <div class="batch_title">Certification List</div>
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            row-key="aaaId"
          >
            <el-table-column prop="name" label="Name" min-width="200">
              <template slot-scope="scope">
                <div class="flex_center_start_box">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="position"
              align="center"
              label="Position"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="country"
              align="center"
              label="Country"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="email"
              align="center"
              label="Email"
              min-width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="" min-width="90">
              <template slot-scope="scope">
                <i slot="reference" class="iconfont icon-shanchu" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-button class="risk_begin_btn" @click="batchDialogVisible = false"
          >Let's Begin</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import * as echarts from "echarts/core";
import Page from "@/views/newLayout/page.vue";
import TabIcon from "@/views/newLayout/tabIcon.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import ContactInfo from "./detail_contactInfo.vue";
import OrgStructure from "./detail_orgStructure.vue";
import {
  getSanctionDateSanction,
  getSanctionProfileNotes,
  getSanctionDetailSource,
  getSanctionRelateInfo,
} from "@/api/newApi.js";
import { getCompanySnap, getCompanyProfile } from "@/api/companyApi";

export default {
  name: "UboDetail",
  mixins: [mixins1],
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  computed: {
    activeTab() {
      return Number(this.$route.query.type || 1);
    },
  },
  components: {
    Header,
    Tollbar,
    Page,
    TabIcon,
    ContactInfo,
    OrgStructure,
  },
  data() {
    return {
      batchDialogVisible: true,
      batchChosen: "1",
      tableData: [
        {
          aaaId: "1",
          name: "Albert A. Gore Jr.",
          position: "CEO",
          country: "China",
          email: "svdvvbaa@apple.com",
        },
        {
          aaaId: "2",
          name: "Andrea Jung",
          position: "CEO",
          country: "United States",
          email: "3sssssss@apple.com",
        },
        {
          aaaId: "3",
          name: "Eddy Cue",
          position: "CEO",
          country: "United States",
          email: "sggggggg@apple.com",
        },
      ],
      activeLabelTab: "",
      // activeTab: this.$route.query.tab || "1",
      detailTabs: [
        { name: "Contact Information", type: "1" },
        { name: "Organizational Structure", type: "2" },
      ],

      companyInfo: {}, //公司信息
      labelList: [],
      radiusX1: 48,
      radiusX2: 62,
      fontSize: 26,
      lineHeight: 28,
      py: "55%",
      companyDQI: 0, //公司值
      countryDQI: 0, //国家值
      companyChart: null,
      countryChart: null,
      //   工具栏
      isShowSearch: true, //默认展示侧边检索
      isShowSelect: false, // 是否显示复选框
      selectList: [],
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: false,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-saomiao",
          name: "Risk Scanning",
          disabled: true,
        },
      ],
      moreToolbarList: [
        {
          icon: "icon-xinyongpingjia",
          name: "Credit Assessment",
          disabled: true,
        },
        {
          icon: "icon-shujufenxi1",
          name: "Data Analysis",
          disabled: true,
        },
        {
          icon: "icon-touzizuhe",
          name: "New Portfolio",
          disabled: true,
        },
        {
          icon: "icon-dayin-dayinji",
          name: "Print",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
    };
  },
  methods: {
    // 搜索
    // 工具栏点击
    onSearch(params, type) {
      // 如果 query 完全一致，直接 return
      let routeData = this.$router.resolve({
        path: "/ubo/list",
        query: {
          keyword: params.searchKeyword,
          selectKey: type,
        },
      });

      window.open(routeData.href, "_blank");
    },
    // 公司信息
    async getCompanyInfo() {
      let res = await getCompanySnap({
        id3a: "156107587326", // this.$route.query.id3a,
      });
      if (res.code == 200) {
        this.companyInfo = res.data;
        document.title = this.companyInfo?.base?.companyName;
        let countryImg = this.getCountryImgUrl(res.data?.base?.countryFlag);
        this.companyInfo.base.img = require("../../../static" + countryImg);
        localStorage.setItem("CompanyBase", JSON.stringify(res.data));
        this.labelList = res.data.labels;
        //   公司DQIecahrts
        this.companyDQI =
          res.data.base.companyDQI != "n.a." && res.data.base.companyDQI != "-"
            ? parseInt(res.data.base.companyDQI)
            : 0;
        this.initCompanyEchart();
        // 国家DQIecharts
        this.countryDQI =
          res.data.base.countryDQI && res.data.base.countryDQI != "-"
            ? parseInt(res.data.base.countryDQI)
            : 0;
        this.initCountryEchart();
      }
    },
    // 公司echarts
    initCompanyEchart() {
      this.companyChart = echarts.init(this.$refs.companyRef);
      let data = this.companyDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.companyChart.setOption(option);
    },
    // 国家echarts
    initCountryEchart() {
      this.countryChart = echarts.init(this.$refs.countryRef);
      let data = this.countryDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: data == 100 ? [5, 5, 5, 5] : [5, 0, 5, 0],
                },
              },
              {
                value: 100 - data,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: data == 0 ? [5, 5, 5, 5] : [0, 5, 0, 5],
                },
              },
            ],
          },
        ],
      };
      this.countryChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.companyChart) {
        this.companyChart.resize();
      }
      if (this.countryChart) {
        this.countryChart.resize();
      }
    },
    handleResize() {
      if (window.innerWidth > 1920) {
        // 大屏幕
        this.radiusX1 = 48;
        this.radiusX2 = 62;
        this.fontSize = 26;
        this.lineHeight = 28;
        this.py = "55%";
      } else {
        this.radiusX1 = 32;
        this.radiusX2 = 41;
        this.fontSize = 16;
        this.lineHeight = 18;
        this.py = "52%";
      }
      this.initCompanyEchart();
      this.initCountryEchart();
      this.resizeChart();
    },

    changeTab(index) {
      if (String(this.$route.query.type) === String(index)) return;
      this.isShowInquiry = false;
      // this.activeTab = index;
      this.$router.replace({
        path: "/leads/contact",
        query: {
          id3a: this.$route.query.id3a,
          keyword: this.$route.query.keyword,
          selectKey: this.$route.query.selectKey,
          type: String(index),
        },
      });
    },
    menuClick(item, isActive) {
      console.log(11111, item, isActive);
      switch (item.name) {
        case "Select":
          if (isActive == "") {
            this.selectList = [];
            // this.onSelectionChange([]);
            // this.$refs.tableRefCompany.clearSelection();
          }
          break;
      }
    },
  },
  mounted() {
    this.getCompanyInfo().then(() => {
      // tab 左右切换按钮状态 修复 通过监听 tab滑动style变化来触发状态更新***********
      this.$nextTick(() => {
        const nav = this.$el.querySelector(".el-tabs__nav");
        if (!nav) return;
        let syncing = false;
        this.observer = new MutationObserver(() => {
          if (syncing) return;
          syncing = true;
          const cur = this.activeLabelTab;
          this.activeLabelTab = "__temp__";
          this.$nextTick(() => {
            this.activeLabelTab = cur;
            syncing = false;
          });
        });
        this.observer.observe(nav, {
          attributes: true,
          attributeFilter: ["style"],
        });
      });
      // ***********************************************************************
    });

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    // 页面销毁时 解除监听tab切换*************************************************
    this.observer && this.observer.disconnect();
    // *************************************************************************
  },
};
</script>
<style scoped>
.contact .page-top-con {
  background: #8e86dd !important;
}
.contact .header_menu_box {
  box-shadow: 0px 2px 4px 0px rgba(109, 133, 144, 0.3) !important;
}
.contact .header_menu_box >>> .tollbar-con-filter-btn {
  background: #8e86dd !important;
}
.new-content-top-right {
  min-width: 326px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.new-content-right-company,
.new-content-right-country {
  width: 124px;
  height: auto;
}
.new-content-right-echart {
  width: 100%;
  height: 62px;
  margin-bottom: 8px;
}
.new-content-right-title {
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
}
.new-content-right-title i {
  margin-left: 6px;
  font-size: 20px;
  color: #ffdb01;
  cursor: pointer;
}
.detail_tab_item.active {
  color: #8e86dd;
}
.detail_content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detail_content_tab_content {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detail_content_tab_con_echart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dialog_1000 >>> .el-dialog__body {
  padding-top: 0;
}
.dialog_1000 .dialog_content_body {
  flex: 1;
  overflow: auto;
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 20px;
}

.batch_title {
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  line-height: 23px;
  text-align: left;
}
.radio_tips {
  margin-left: 26px;
  margin-top: 14px;
  margin-bottom: 30px;
  font-size: 20px;
  color: #666666;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}
.radio_tips .el-button.el-button--text {
  padding: 0;
  font-size: 20px;
  color: #8e86dd;
  line-height: 20px;
}
.radio_tips .el-button + .el-button {
  margin-left: 40px;
}
.dialog_content_body >>> .el-radio {
  justify-content: flex-start;
}
.dialog_content_body >>> .el-radio .el-radio__label {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
}
.dialog_content_body >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #685ed1;
}
.dialog_content_body >>> .el-radio__input.is-checked .el-radio__inner::after {
  background-color: #685ed1;
}
.dialog_content_body >>> .icon-shanchu {
  cursor: pointer;
  font-size: 28px;
  color: #f56b6b;
}
@media (max-width: 1920px) {
  .new-content-top-right {
    margin-top: 7px;
    min-width: 218px;
  }
  .new-content-right-company,
  .new-content-right-country {
    width: 82px;
  }
  .new-content-right-echart {
    height: 42px;
    margin-bottom: 6px;
  }
  .new-content-right-title {
    line-height: 14px;
    font-size: 12px;
  }
  .new-content-right-title i {
    margin-left: 4px;
    font-size: 14px;
  }
  .new-content-detail-wrap {
    top: 168px;
    padding: 0 14px;
  }

  .batch_title {
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 16px;
  }
  .radio_tips {
    margin-left: 26px;
    margin-top: 12px;
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 22px;
  }
  .radio_tips .el-button.el-button--text {
    font-size: 16px;
    line-height: 16px;
  }
  .radio_tips .el-button + .el-button {
    margin-left: 30px;
  }
  .dialog_content_body >>> .el-radio .el-radio__label {
    font-size: 14px;
  }
  .dialog_content_body >>> .icon-shanchu {
    font-size: 22px;
  }
}
</style>
